import { createContext } from 'react';
import { Drink } from '../interfaces';

export default createContext<Drink[]>([]);
